import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'
import api from '@/helpers/fetch'

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class Search extends Vue {
	blogPosts = [] as Array<any>
	loading = true
	filters = {
		tags: [] as Array<any>,
		title: '',
	}

	options = {
		tags: [] as Array<any>,
	}

	clearForm() {
		this.filters.title = ''
		this.filters.tags = []
	}

	openSearch() {
		if (this.filters.tags.length <= 0 && !this.filters.title) {
			this.$bvToast.toast(
				'Adicione uma tag ou digite algum termo para pesquisa',
				{
					title: 'Ops...',
					variant: 'warning',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
			return
		}

		this.$router.push({
			path: '/conteudos/navegar',
			query: { tags: this.filters.tags, title: this.filters.title },
		})
	}

	async loadContentTags() {
		this.loading = true
		const res = await api.get('/api/blogging/content-tags')
		this.loading = false
		this.options.tags.length = 0
		this.options.tags = res.data
	}

	async mounted() {
		await this.loadContentTags()
	}
}
